import { get } from '..';
import routes from './routes';

const AuditLogServices = {
  getAllAuditLogs: async (params) => {
    const data = await get(routes.getAllAuditLogs, params);
    return data;
  },
};

export default AuditLogServices;
